import { useContext } from 'react'
import { Checkbox } from 'react-aria-components'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'
import { getOnboardingLocalizedName } from '../helper'
import { NewUserOnboardingContext } from '../NewUserOnboardingContext'
import {
  NewUserOnboardingFormStep,
  NewUserOnboardingSkipButton,
} from '../NewUserOnboardingFormStep'
import { useNewUserOnboardingFormContext } from '../newUserOnboardingForm'

function CategorySelector(props: {
  onChange: (value: string[]) => void
  value?: string[]
  disabled?: boolean
}) {
  const { i18n } = useTranslation(['common', 'user'])
  const { onboardingDataRes } = useContext(NewUserOnboardingContext)
  const { onboardingData } = onboardingDataRes ?? {}
  const selectedCategories = props.value ?? []
  return (
    <div className="flex flex-wrap gap-x-3 gap-y-3 mt-4">
      {Object.entries(onboardingData?.categoryNames ?? {}).map(
        ([category, names]) => {
          const isSelected = selectedCategories.includes(category)
          return (
            <Checkbox
              key={category}
              className={twMerge(
                'rounded-full ring-2 transition px-4 py-2 text-center text-sm truncate hover:bg-theme-primary/5 focus-visible:bg-theme-primary/5',
                isSelected
                  ? 'ring-theme-primary'
                  : 'ring-neutral-200 dark:ring-neutral-600 hover:ring-theme-primary/50 hover:dark:ring-theme-primary/60 focus-visible:ring-theme-primary/50 focus-visible:dark:ring-theme-primary/60',
              )}
              isSelected={isSelected}
              isDisabled={props.disabled}
              onChange={isSelected => {
                if (isSelected) {
                  props.onChange([...selectedCategories, category])
                } else {
                  props.onChange(
                    selectedCategories.filter(item => item !== category),
                  )
                }
              }}
            >
              {getOnboardingLocalizedName(names, i18n)}
            </Checkbox>
          )
        },
      )}
    </div>
  )
}

export function NewUserCategoryStep() {
  const { t } = useTranslation(['common', 'user'])
  const form = useNewUserOnboardingFormContext()
  const { categories } = form.values
  const { actionBusy } = useContext(NewUserOnboardingContext)
  return (
    <NewUserOnboardingFormStep disableNext={(categories?.length ?? 0) === 0}>
      <h2 className="text-xl font-bold mb-4">
        <NewUserOnboardingSkipButton />
        {t('user:onboarding.category.title')}
      </h2>
      <p className="text-neutral-600 dark:text-neutral-400">
        {t('user:onboarding.category.info')}
      </p>
      <CategorySelector
        disabled={actionBusy}
        {...form.getInputProps('categories')}
      />
    </NewUserOnboardingFormStep>
  )
}
